import { render, staticRenderFns } from "./UiCardContentTitle.vue?vue&type=template&id=4366b444&scoped=true&"
var script = {}
import style0 from "./UiCardContentTitle.vue?vue&type=style&index=0&id=4366b444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366b444",
  null
  
)

export default component.exports